import { defineComponent as _defineComponent } from 'vue';
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, createElementVNode as _createElementVNode, withDirectives as _withDirectives, unref as _unref, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-45b1b015"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "select-value" };
const _hoisted_2 = ["value"];
const _hoisted_3 = {
    key: 0,
    class: "select-value__connector"
};
const _hoisted_4 = ["value"];
import { computed, watch, reactive, inject } from 'vue';
import { useAudienceManager } from '@/features/AudienceManager/composables/useAudienceManager';
export default /*#__PURE__*/ _defineComponent({
    __name: 'Select',
    props: {
        modelValue: {}
    },
    emits: ['update:modelValue'],
    setup(__props, { emit }) {
        const props = __props;
        const groupIndex = inject('groupIndex');
        const isInclude = inject('isInclude');
        const { isBetweenOperator, selectedCriteriaDetails } = useAudienceManager(isInclude, groupIndex);
        const getOptions = computed(() => selectedCriteriaDetails?.value?.options || {});
        const optionKeysList = computed(() => Object.keys(getOptions.value));
        const state = reactive({
            selectedValues: [...props.modelValue],
        });
        const emitUpdate = () => {
            emit('update:modelValue', state.selectedValues);
        };
        watch(() => props.modelValue, newVal => {
            state.selectedValues = [...(newVal || [])];
        }, { immediate: true, deep: true });
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _withDirectives(_createElementVNode("select", {
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((state.selectedValues[0]) = $event)),
                    onChange: emitUpdate
                }, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(optionKeysList.value, (optionKey) => {
                        return (_openBlock(), _createElementBlock("option", {
                            key: optionKey,
                            value: optionKey
                        }, _toDisplayString(getOptions.value[optionKey]), 9, _hoisted_2));
                    }), 128))
                ], 544), [
                    [_vModelSelect, state.selectedValues[0]]
                ]),
                (_unref(isBetweenOperator))
                    ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(_ctx.$t('and')), 1))
                    : _createCommentVNode("", true),
                (_unref(isBetweenOperator))
                    ? _withDirectives((_openBlock(), _createElementBlock("select", {
                        key: 1,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((state.selectedValues[1]) = $event)),
                        onChange: emitUpdate
                    }, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(optionKeysList.value, (optionKey) => {
                            return (_openBlock(), _createElementBlock("option", {
                                key: optionKey,
                                value: optionKey
                            }, _toDisplayString(getOptions.value[optionKey]), 9, _hoisted_4));
                        }), 128))
                    ], 544)), [
                        [_vModelSelect, state.selectedValues[1]]
                    ])
                    : _createCommentVNode("", true)
            ]));
        };
    }
});
